"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _style = _interopRequireDefault(require("./style.scss"));
var _cookies = require("../../utils/cookies");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EPaySystemError = /*#__PURE__*/function (_React$Component) {
  function EPaySystemError(props) {
    var _this;
    _classCallCheck(this, EPaySystemError);
    _this = _callSuper(this, EPaySystemError, [props]);
    _this.linkClick = _this.linkClick.bind(_this);
    _this.setAdditionalAttribute = _this.setAdditionalAttribute.bind(_this);
    return _this;
  }
  _inherits(EPaySystemError, _React$Component);
  return _createClass(EPaySystemError, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.analytics.track('nav', {
        event_category: 'system tag',
        event_action: 'system verified',
        event_detail: 'Conversion Error Page',
        event_label: 'Conversion Error Page',
        knockout_error_type: 'Application Error',
        knockout_error_description: 'Generic error page',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "linkClick",
    value: function linkClick(event) {
      this.props.analytics.track('click', {
        event_category: 'page tag',
        event_action: 'link click',
        event_detail: event.target.id,
        event_label: 'epayerror',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "setAdditionalAttribute",
    value: function setAdditionalAttribute() {
      var userId = this.props.userId;
      var additionalAttribute = {};
      additionalAttribute.userId = userId ? userId : '';
      return additionalAttribute;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "medium-container"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "margin-top-xx-large tds-h1--small"
      }, "We\u2019re sorry."), /*#__PURE__*/React.createElement("p", {
        className: "margin-top-xx-large tds-large"
      }, "MyTravelers is temporarily unavailable."), /*#__PURE__*/React.createElement("div", {
        className: "tds-large"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.linkClick,
        id: "CONTINUETOEPAY",
        href: process.env.EXPRESSPAY_URL
      }, "Continue to ePay")), /*#__PURE__*/React.createElement("hr", {
        className: "content-divider margin-top-xx-large shorten-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "margin-top-xx-large"
      }, "If you continue to experience this problem and need to ", /*#__PURE__*/React.createElement("span", {
        className: "tds-bold"
      }, "pay your bill "), "now,"), /*#__PURE__*/React.createElement("div", null, "please call us at ", /*#__PURE__*/React.createElement("a", {
        onClick: this.linkClick,
        id: "PHONENUMBER",
        href: 'tel:+' + process.env.EPAY_CALLUS_NUM
      }, process.env.EPAY_CALLUS_NUM), ",  7 AM to 8 PM ET, Monday\u2013Friday."));
    }
  }]);
}(React.Component);
var _default = exports["default"] = EPaySystemError;